import { Box, CircularProgress, Container, Typography } from '@mui/material';
import { Navigate } from 'react-router-dom';
import AgentCriteriaEditor, { ZoneValue } from '../../components/LeadsVo/AgentCriteriaEditor';
import RdvLocationEditor from '../../components/LeadsVo/RdvLocationEditor';
import {
  useLeadsVoAgent,
  useLeadsVoResearch,
  useUpdateBusinessHours,
  useUpdateProfile,
  useUpdateResearch,
  useUpdateZone,
} from '../../hooks/useLeadsVoQueries';

const Settings = () => {
  const { data: agentData, isLoading: agentLoading } = useLeadsVoAgent();
  const { data: researchData, isLoading: researchLoading } = useLeadsVoResearch();
  const updateZone = useUpdateZone();
  const updateResearch = useUpdateResearch();
  const updateBusinessHours = useUpdateBusinessHours();
  const updateProfile = useUpdateProfile();

  if (agentLoading || researchLoading) {
    return <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh"><CircularProgress sx={{ color: '#FDBB5F' }} /></Box>;
  }

  if (agentData?.partner?.statut !== 'active') {
    return <Navigate to="/leads-vo/onboarding" replace />;
  }

  const p = agentData.partner;
  const initialZone: ZoneValue | null = p.zone_mode
    ? { mode: p.zone_mode, cities: p.zone_cities ?? [], center: p.zone_center ?? '', radius_km: p.zone_radius_km ?? null }
    : null;

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography sx={{ fontWeight: 900, fontSize: 28, color: '#262626', mb: 4 }}>Mes critères</Typography>
      <RdvLocationEditor
        initialLocation={p.rdv_location ?? null}
        initialAddress={p.agency_address}
        onSave={(payload) => updateProfile.mutateAsync(payload)}
      />
      <AgentCriteriaEditor
        initialZone={initialZone}
        initialResearch={researchData?.research?.criteres_vehicule ?? null}
        initialHours={p.business_hours ?? null}
        onSaveZone={(payload) => updateZone.mutateAsync(payload)}
        onSaveResearch={(payload) => updateResearch.mutateAsync(payload)}
        onSaveHours={(hours) => updateBusinessHours.mutateAsync(hours)}
      />
    </Container>
  );
};

export default Settings;
